const reload = () => window.location.reload();
const assign = (URL) => window.location.assign(URL);

export { reload, assign };
